export function normalizeString(str) {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
}

export function filterMaterials(filters, data, updateFilteredList) {
    const updatedFilters = [...filters];

    if (updatedFilters.length === 0) {
        updateFilteredList([...data]);
        return;
    }

    const searchTerms = updatedFilters.map(normalizeString);

    const isGrouped = data.length > 0 && Array.isArray(data[0].materials);

    if (isGrouped) {
        const filteredList = data
            .map((group) => {
                const batchMatch =
                    group.batch &&
                    searchTerms.some((term) => normalizeString(String(group.batch)).includes(term));

                if (batchMatch) {
                    return { ...group };
                }

                const filteredMaterials = group.materials.filter((mat) => {
                    const normalizedItemName = normalizeString(mat.name);
                    return searchTerms.some((term) => normalizedItemName.includes(term));
                });

                return filteredMaterials.length > 0
                    ? { ...group, materials: filteredMaterials }
                    : null;
            })
            .filter((group) => group !== null);

        updateFilteredList(filteredList);
    } else {
        const filteredList = data.filter((item) => {
            const normalizedItemName = normalizeString(item.name);
            return searchTerms.some((term) => normalizedItemName.includes(term));
        });

        updateFilteredList(filteredList);
    }
}
